export type SocialIconName
  = | 'square-youtube'
    | 'square-x-twitter'
    | 'square-bluesky'
    | 'square-linkedin'
    | 'discord'

export const socialIconMap: Record<SocialIconName, string> = {
  'square-youtube': 'fa6-brands:square-youtube',
  'square-x-twitter': 'fa6-brands:square-x-twitter',
  'square-bluesky': 'fa6-brands:square-bluesky',
  'square-linkedin': 'fa6-brands:linkedin',
  'discord': 'fa6-brands:discord',
}

// Pick the right icon based on the actual URL contents — handy for
// per-employee social fields where someone may drop a Bluesky URL
// into the `twitter` field, etc.
export function socialIconForUrl(
  url: string,
  fallback: { name: string, icon: SocialIconName },
): { name: string, icon: SocialIconName } {
  if (/bsky\.app|bsky\.social|\.bsky\./i.test(url))
    return { name: 'Bluesky', icon: 'square-bluesky' }
  if (/twitter\.com|x\.com/i.test(url))
    return { name: 'X', icon: 'square-x-twitter' }
  if (/linkedin\.com/i.test(url))
    return { name: 'LinkedIn', icon: 'square-linkedin' }
  if (/youtube\.com|youtu\.be/i.test(url))
    return { name: 'YouTube', icon: 'square-youtube' }
  if (/discord\.gg|discord\.com/i.test(url))
    return { name: 'Discord', icon: 'discord' }
  return fallback
}
